import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Heading from '../../atoms/Heading'
import Text from '../../atoms/Text'
import styles from './ProjectCard.module.css'

/**
 * Composant Molécule : ProjectCard
 *
 * Carte de projet avec image, titre et catégorie
 *
 * @component
 */
const ProjectCard = ({ title, category, year, color, image, onClick, link, external }) => {
  // Afficher certaines images à leur taille originale
  const isCaveDeZae = image && image.includes('cave-zae')
  const isCalendrier = image && image.includes('calendrier-tournoi')
  const isAtv = image && image.includes('atv')
  const isForumAsso = image && image.includes('forum-asso')
  const isVoco = image && image.includes('voco-2026')
  const useContain = isCaveDeZae || isCalendrier || isAtv || isForumAsso || isVoco

  const content = (
    <>
      <div
        className={styles.cardImage}
        style={{
          backgroundImage: image ? `url(${image})` : undefined,
          backgroundSize: useContain ? (isAtv ? '155%' : 'contain') : 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className={styles.cardOverlay} />
      </div>
      <div className={styles.cardInfo}>
        <Text size="small" className={styles.cardCategory}>
          {category}
        </Text>
        <Heading level={3} className={styles.cardTitle}>
          {title}
        </Heading>
        <Text size="small" className={styles.cardYear}>
          {year}
        </Text>
      </div>
    </>
  )

  if (link && external) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.card}
        style={{ '--accent-color': color }}
      >
        {content}
      </a>
    )
  }

  if (link) {
    return (
      <Link
        to={link}
        className={styles.card}
        style={{ '--accent-color': color }}
      >
        {content}
      </Link>
    )
  }

  return (
    <div
      className={styles.card}
      onClick={onClick}
      style={{ '--accent-color': color }}
    >
      {content}
    </div>
  )
}

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  image: PropTypes.string,
  onClick: PropTypes.func,
  link: PropTypes.string,
  external: PropTypes.bool,
}

export default ProjectCard
